import React from 'react'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import WarningIcon from '@material-ui/icons/Warning'
import { green, amber, blue, red } from '@material-ui/core/colors'
import { SnackbarContent } from '../../Atoms'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
}

const useStyles = makeStyles({
  success: props => ({
    backgroundColor: props.success ? props.success : green[700]
  }),
  error: props => ({
    backgroundColor: props.error ? props.error : red[500]
  }),
  info: props => ({
    backgroundColor: props.info ? props.info : blue[500]
  }),
  warning: props => ({
    backgroundColor: props.warning ? props.warning : amber[700]
  }),
  root: props => (props.root ? props.root : {}),
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: 8
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
})

const propTypes = {
  /** Guidelines: https://rfg-projects.atlassian.net/wiki/spaces/RP/pages/569475249/RFG+Platform+-+QA+ID+Standards */
  id: PropTypes.string.isRequired,
  /** Override the styles applied to the component. */
  classes: PropTypes.any,
  /** Content of the component*/
  message: PropTypes.node,
  /** Callback fired when the a close is triggered. **/
  onClose: PropTypes.func,
  /** Selection of different variant for different usage. **/
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
}

/**
 * ## Toast provide informative messages in the browser.
 */

const Toast = props => {
  const { message, onClose, variant, id, ...other } = props
  const classes = useStyles(other)
  const Icon = variantIcon[variant]

  return (
    <SnackbarContent
      id={id}
      className={clsx(classes[variant], classes.root)}
      aria-describedby='client-snackbar'
      data-cid='SnackbarWrapper-root'
      message={
        <span id='client-snackbar' className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key='close'
          aria-label='Close'
          color='inherit'
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  )
}

Toast.propTypes = propTypes

export default Toast
